import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import Footer from "./shared/Footer";
import { ApiLoadingOverlay } from "./shared/Spinner";
import axios from "axios";
import FirebaseMessaging from "../app/services/FirebaseMessaging";
import { apiRequest } from "./apiServices/allApi";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const FCM_TOKEN_KEY = "firebaseToken";

async function updatedToken(fcmtoken) {
  if (
    !fcmtoken ||
    window.location.pathname === "/adminlogin" ||
    localStorage.getItem(FCM_TOKEN_KEY) === fcmtoken
  ) {
    return;
  }

  const token = localStorage.getItem("token");
  if (!token) return;

  const headers = { Authorization: `Bearer ${token}` };
  try {
    await apiRequest(
      `updateToken?firebaseToken=${encodeURIComponent(fcmtoken)}`,
      "GET",
      null,
      headers,
    );
    localStorage.setItem(FCM_TOKEN_KEY, fcmtoken);
  } catch (error) {}
}

function App(props) {
  const [state, setState] = useState({
    tokenfirebase: "",
    message: "",
  });

  useEffect(() => {
    let active = true;

    const applyRouteLayout = () => {
      window.scrollTo(0, 0);
      const fullPageLayoutRoutes = ["/adminlogin"];
      const isFullPage = fullPageLayoutRoutes.includes(
        props.location.pathname,
      );

      setState((prev) =>
        prev.isFullPageLayout === isFullPage
          ? prev
          : { ...prev, isFullPageLayout: isFullPage },
      );

      const bodyWrapper = document.querySelector(".page-body-wrapper");
      if (bodyWrapper) {
        if (isFullPage) {
          bodyWrapper.classList.add("full-page-wrapper");
        } else {
          bodyWrapper.classList.remove("full-page-wrapper");
        }
      }
    };

    applyRouteLayout();

    const token = localStorage.getItem("token");
    if (!token) return;

    apiRequest(`admin/me_data`, "GET", null, {
      Authorization: `Bearer ${token}`,
    })
      .then((res) => {
        if (!active) return;
        const data = res.data || {};
        localStorage.setItem("id", data._id || "");
        localStorage.setItem("user", data.user_type || "");

        const p = data.permissions || {};
        const legalData = Boolean(p.legalData ?? p.updateLegalData ?? false);

        localStorage.setItem("updateLegalData", legalData ? "true" : "false");

        setState((prev) => ({
          ...prev,
          usertype: data.user_type,
          userAname: data.Name,
          dashboard: Boolean(p.dashboard),
          earnings: Boolean(p.earnings),
          allAdmins: Boolean(p.allAdmins),
          newAdmin: Boolean(p.newAdmin),
          adminKyc: Boolean(p.adminKyc),
          sitesettings: Boolean(p.sitesettings),
          Gatewaysettings: Boolean(p.Gatewaysettings),
          addBankDetail: Boolean(p.addBankDetail),
          viewBankDetail: Boolean(p.viewBankDetail),
          allAgent: Boolean(p.allAgent),
          allUsers: Boolean(p.allUsers),
          pendingKyc: Boolean(p.pendingKyc),
          completedKyc: Boolean(p.completedKyc),
          rejectKyc: Boolean(p.rejectKyc),
          pushNotification: Boolean(p.pushNotification),
          legalData,
          conflictChallenges: Boolean(p.conflictChallenges),
          pendingChallenges: Boolean(p.pendingChallenges),
          allChallenges: Boolean(p.allChallenges),
          completedChallenges: Boolean(p.completedChallenges),
          cancelledChallenges: Boolean(p.cancelledChallenges),
          runningChallenges: Boolean(p.runningChallenges),
          newChallenge: Boolean(p.newChallenge),
          allWithdrawlRequests: Boolean(p.allWithdrawlRequests),
          depositManual: Boolean(p.depositManual),
          depositHistory: Boolean(p.depositHistory),
          bonus: Boolean(p.bonus),
          penalty: Boolean(p.penalty),
          bonusReport: Boolean(p.bonusReport),
          depositReport: Boolean(p.depositReport),
          penaltyReport: Boolean(p.penaltyReport),
          withdrawlReport: Boolean(p.withdrawlReport),
          blockUser: Boolean(p.blockUser),
        }));
      })
      .catch(() => {});

    FirebaseMessaging.requestNotificationPermission()
      .then((tokenfirebase) => {
        if (!active) return;
        updatedToken(tokenfirebase);
        FirebaseMessaging.onMessage((payload) => {
          setState((prev) => ({
            ...prev,
            message: payload?.notification?.body,
          }));
        });
      })
      .catch(() => {});

    applyRouteLayout();

    return () => {
      active = false;
    };
    // Mount setup matches componentDidMount. Route changes are handled below.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fullPageLayoutRoutes = ["/adminlogin"];
    const isFullPage = fullPageLayoutRoutes.includes(props.location.pathname);

    setState((prev) =>
      prev.isFullPageLayout === isFullPage
        ? prev
        : { ...prev, isFullPageLayout: isFullPage },
    );

    const bodyWrapper = document.querySelector(".page-body-wrapper");
    if (bodyWrapper) {
      if (isFullPage) {
        bodyWrapper.classList.add("full-page-wrapper");
      } else {
        bodyWrapper.classList.remove("full-page-wrapper");
      }
    }
  }, [props.location]);

  const navbarComponent = !state.isFullPageLayout ? (
    <Navbar usertype={state.usertype} userAname={state.userAname} />
  ) : (
    ""
  );
  const sidebarComponent = !state.isFullPageLayout ? (
    <>
      <Sidebar
        usertype={state.usertype}
        dashboard={state.dashboard}
        earnings={state.earnings}
        allAdmins={state.allAdmins}
        newAdmin={state.newAdmin}
        adminKyc={state.adminKyc}
        sitesettings={state.sitesettings}
        Gatewaysettings={state.Gatewaysettings}
        addBankDetail={state.addBankDetail}
        viewBankDetail={state.viewBankDetail}
        allAgent={state.allAgent}
        allUsers={state.allUsers}
        pendingKyc={state.pendingKyc}
        completedKyc={state.completedKyc}
        rejectKyc={state.rejectKyc}
        pushNotification={state.pushNotification}
        legalData={state.legalData}
        conflictChallenges={state.conflictChallenges}
        pendingChallenges={state.pendingChallenges}
        allChallenges={state.allChallenges}
        completedChallenges={state.completedChallenges}
        cancelledChallenges={state.cancelledChallenges}
        runningChallenges={state.runningChallenges}
        newChallenge={state.newChallenge}
        allWithdrawlRequests={state.allWithdrawlRequests}
        depositManual={state.depositManual}
        depositHistory={state.depositHistory}
        bonus={state.bonus}
        penalty={state.penalty}
        bonusReport={state.bonusReport}
        depositReport={state.depositReport}
        penaltyReport={state.penaltyReport}
        withdrawlReport={state.withdrawlReport}
        blockUser={state.blockUser}
      />
    </>
  ) : (
    ""
  );
  const footerComponent = !state.isFullPageLayout ? <Footer /> : "";

  return (
    <div className="container-scroller">
      <ApiLoadingOverlay />
      {sidebarComponent}
      <div className="container-fluid page-body-wrapper">
        {navbarComponent}
        <div className="main-panel">
          <div className="content-wrapper" >
            <AppRoutes />
          </div>
          {footerComponent}
        </div>
      </div>
    </div>
  );
}

export default withRouter(App);
